import { InvoicesOrder } from "features/invoices-order";
import ErrorPage from "pages/404";
import BottlesPage from "pages/bottles";
import ConsolidatedStocks from "pages/consolidated-stocks";
import ControlPanel from "pages/control-panel/index";
import DailyDelivery from "pages/daily-delivery";
import ForbiddenAccess from "pages/forbidden-access/index";
import { LoadBuilding } from "pages/load-building";
import { MassArrivalPage } from "pages/mass-arrival";
import { NotificationCenter } from "pages/notification-center";
import OrdersPage from "pages/orders";
import OrderVolumePage from "pages/orderVolume";
import ProductionPlanSupplier from "pages/production-plan-supplier";
import Suggestions from "pages/suggestions";
import SupplierProductionPlan from "pages/supplier-production-plan";
import { Route, Switch } from "react-router-dom";
import { profileAdmin } from "services/permissions/getPermissions";
import AutoLoadOptimization from "../pages/auto-load-optimization";
import ComposicaoCarga from "../pages/composicao-carga";
import EstoqueFornecedor from "../pages/estoque-fornecedor";
import ItensCriticos from "../pages/gerencial/itens-criticos";
import RiscosPassivos from "../pages/gerencial/riscos-passivos";
import GridVision from "../pages/grid-vision";
import LoadComposition from "../pages/load-composition";
import { LoadCompositionProvider } from "../pages/load-composition/context/loadCompositionContext";
import LoadCompositionBuilding from "../pages/load-composition-building";
import MasterData from "../pages/master-data";
import OtimizacaoCarga from "../pages/optimization";
import OrdersVisionDetail from "../pages/orders-vision-detail";
import PrimaryMaterialScheduleList from "../pages/primary-material-schedule";
import Relatorios from "../pages/relatorios";
import Stocks from "../pages/stocks";
import StocksDetail from "../pages/stocks-detail";
import TasksVision from "../pages/tasks-vision";

const renderOrForbid = (condition, component) => {
  if (condition) return component;
  else return ForbiddenAccess;
};

const AppRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={TasksVision} />
      <Route exact path="/error" component={ErrorPage} />
      <Route exact path="/orders" component={OrdersPage} />
      <Route exact path="/suggestions" component={Suggestions} />
      <Route exact path="/volume" component={OrderVolumePage} />
      <Route exact path="/bottles" component={BottlesPage} />
      <Route exact path="/mass-arrival" component={MassArrivalPage} />
      <Route path={`/ordersVisionDetail/:orderId/:typeNeed`} component={OrdersVisionDetail} />
      <Route exact path={`/stocks`} component={Stocks} />
      <Route path={`/stocksDetail/:familyId/:itemId?/:typeNeed?`} component={StocksDetail} />
      <Route path={`/gridVision/:familyId?/:date?/:datetype?`} component={GridVision} />
      <Route path={`/relatorios`} component={Relatorios} />
      <Route path={`/master-data`} component={MasterData} />
      <Route exact path={`/gerencial`} component={RiscosPassivos} />
      <Route path={`/riscos-passivos`} component={RiscosPassivos} />
      <Route path={`/itens-criticos`} component={ItensCriticos} />
      <Route exact path={`/composicao`} component={ComposicaoCarga} />
      <Route path={`/composicao/:idPedido`} component={ComposicaoCarga} />
      <Route path={`/load-optimization`} component={OtimizacaoCarga} />
      <Route path={`/estoqueFornecedor`} component={EstoqueFornecedor} />
      <Route path={`/autoLoadOptimization`} component={AutoLoadOptimization} />
      <Route path={`/primaryMaterialSchedule`} component={PrimaryMaterialScheduleList} />
      <Route path={`/consolidated-stocks`} component={ConsolidatedStocks} />
      <Route exact path={`/load-building`} component={LoadBuilding} />
      <Route exact path={`/orders/:orderSapCode/invoices`} component={InvoicesOrder} />
      <Route exact path={"/notification-center"} component={NotificationCenter} />
      <Route exact path={"/supplier-production-plan"} component={SupplierProductionPlan} />
      <Route exact path={"/production-plan-supplier"} component={ProductionPlanSupplier} />
      <Route exact path={"/daily-delivery"} component={DailyDelivery} />
      <Route
        exact
        path={"/control-panel"}
        component={renderOrForbid(profileAdmin(), ControlPanel)}
      />
      <Route exact path={"/forbidden-access"} component={ForbiddenAccess} />
      <LoadCompositionProvider>
        <Route exact path={`/loadComposition`} component={LoadComposition} />
        <Route
          path={`/loadCompositionBuilding/destino/:destinoId/:destinoName/date/:dia/:hora/:composicaoId?/:fornecedorId?/:idxSelected?`}
          component={LoadCompositionBuilding}
        />
      </LoadCompositionProvider>
    </Switch>
  );
};

export default AppRoutes;
